module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Readers love")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("R")]), _c('span', {
    staticClass: "t3"
  }, [_vm._v("EMMY")]), _c('span', {
    staticClass: "t2"
  }, [_vm._v(" D")]), _c('span', {
    staticClass: "t3"
  }, [_vm._v("UCHENE")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("Deliver Me")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“This story is about forgiveness and trust and finally standing up for what you want.”")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("—Prism Book Alliance")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("This is Love ")]), _c('span', {
    staticClass: "t6"
  }, [_vm._v("(with Allison Cassatta)")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“I enjoyed this straightforward erotic romance of two men finding their life partner and making a life together.”")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("—The Book Vixen")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“This is a must read for us hopeless romantics! Two gorgeous alpha males falling in love and figuring out how to keep it together and keep it real.”")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("—MM Good Book Reviews")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("“"), _c('span', {
    staticClass: "t8"
  }, [_vm._v("This is Love")]), _vm._v(" is a sweet, low-angst book. It is a good story about two damaged men who find love with each other.”")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("—The Novel Approach")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ac69130","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/002.vue
// module id = 57
// module chunks = 0